import { render, staticRenderFns } from "./ContenidoEvaluacion.vue?vue&type=template&id=50dea35a"
import script from "./ContenidoEvaluacion.vue?vue&type=script&lang=js"
export * from "./ContenidoEvaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports